export default "__VITE_ASSET__B8rwk3T0__"